<template>
    <div v-show="show" aria-live="polite">
      <hp5-heading size-selection="lg" tag-selection="h2">Sorry, we didn't find any results.</hp5-heading>
      <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm"></hp5-spacing-vertical>
      <hp5-semantic size-selection="sm"
        ><div>Try updating your search:</div>
        <ul>
          <li>Change your filters</li>
          <li>Change your network selection</li>
          <li>Use different keywords</li>
          <li>Check your spelling</li>
          <li>Adjust your location</li>
        </ul>
      </hp5-semantic>
      <hp5-spacing-vertical xs="lg" sm="lg" md="lg" lg="lg"></hp5-spacing-vertical>
    </div>
</template>
<script setup>
    const { hasSearched, searchResults } = useFCPModel()
    const show = computed(() => hasSearched.value && searchResults.value && searchResults.value.length == 0)
</script>